"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import $ from "jquery";
import _ from "underscore";
import ApiService from "../services/api_service";
import "../util/fetch";
import { factorInIndexerMode, isIndexerMode } from "./index_audit_split_mode";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
export const UPDATE_DOCUMENT_GROUPS_TIMEOUT_MS = 12e4;
class DocumentIndexerService {
  constructor(documentBatch, DataStoreService, accountApi, propsLocation) {
    __publicField(this, "documentBatch");
    __publicField(this, "steps");
    __publicField(this, "step", "assignCarrier");
    __publicField(this, "_dataStoreService");
    __publicField(this, "_accountApi");
    __publicField(this, "_propsLocation");
    // An arrow field because react_indexer passes it detached as the load
    // search `searcher` prop.
    __publicField(this, "searchForLoads", (terms) => {
      return $.get("/api/load_searches/by_location", terms).then(
        this._dataStoreService.responseHandler,
        _.identity
      );
    });
    this.documentBatch = documentBatch;
    this._dataStoreService = DataStoreService;
    this._accountApi = accountApi;
    this._propsLocation = propsLocation;
    this.steps = [
      "assignCarrier",
      "assignTypes",
      "assignGroups",
      this._allDocumentsGroupedStep(),
      factorInIndexerMode(propsLocation) ? "review" : null
    ].filter((s) => s != null);
    this._initialize();
  }
  _allDocumentsGroupedStep() {
    if (this._accountApi.hasRole("Factor")) {
      if (isIndexerMode(this._propsLocation)) {
        return "assignDebtor";
      } else {
        return "extractData";
      }
    } else {
      return "assignLoads";
    }
  }
  stepNumber() {
    return this.steps.indexOf(this.step);
  }
  stepNumberForName(stepName) {
    return this.steps.indexOf(stepName);
  }
  updateDocumentGroups(documentBatchId) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: `/api/document_groups/${documentBatchId}`,
        type: "PUT",
        contentType: "application/json",
        timeout: UPDATE_DOCUMENT_GROUPS_TIMEOUT_MS
      }).then((data) => {
        if (data && data.redirect_to_dashboard) {
          ToDashboardWithFilters(this._propsLocation);
          return Promise.reject({ redirected: true });
        }
        const r = this._dataStoreService.updateStores(data);
        this.updateStep();
        return r.document_batch;
      }),
      "The document groups did not save, please try again.",
      { caller: "DocumentIndexerService.updateDocumentGroups" }
    );
  }
  clearGroupingErrors(documentIds) {
    return $.post("/api/documents/clear_grouping_errors", {
      document_ids: documentIds
    }).then((data) => {
      const r = this._dataStoreService.updateStores(data);
      this.updateStep();
      return r.document_batch;
    });
  }
  currentGuessedLoads(group, includeRelated) {
    const ids = this.currentLoadIds(group.documents);
    const selectedLoadIds = _.uniq(this.selectedLoadIds(group.documents));
    const data = {
      carrier_id: this.documentBatch.carrier_id,
      load_ids: ids,
      load_state_ids: selectedLoadIds,
      include_related: includeRelated,
      group_id: group.id
    };
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/load_searches/by_load_id",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(data)
      }).then((data2) => {
        if (data2 && data2.related) {
          this._dataStoreService.responseHandler(data2.related);
        }
        return data2;
      }, _.identity),
      null,
      { caller: "DocumentIndexerService.currentGuessedLoads" }
    );
  }
  selectedLoadIds(documents) {
    return _.flatten(
      _.compact(_.pluck(_.pluck(documents, "data"), "load_state_ids"))
    );
  }
  currentLoadIds(documents) {
    return _.chain(documents).pluck("pages").flatten().pluck("load_ids").flatten().compact().value();
  }
  updateDocumentException(message, exception, documentGroup) {
    const data = { resolution: message };
    return this._updateException(data, documentGroup, exception, "", "PUT");
  }
  resolveDocumentException(exception, documentGroup) {
    const data = { ignore: documentGroup.ignored };
    return this._updateException(
      data,
      documentGroup,
      exception,
      "/resolve",
      "POST"
    );
  }
  _updateException(data, documentGroup, exception, action, type) {
    return $.ajax({
      url: `/api/document_groups/${documentGroup.id}/exceptions/${exception.id}${action}`,
      type,
      contentType: "application/json",
      data: JSON.stringify(data)
    }).then(this._dataStoreService.responseHandler, _.identity);
  }
  saveDocumentException(message, documentGroup, ignore) {
    const exception = { message, ignore };
    return $.ajax({
      url: `/api/document_groups/${documentGroup.id}/exceptions`,
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(exception)
    }).then(this._dataStoreService.responseHandler, _.identity);
  }
  _initialize() {
    this.updateStep();
  }
  _allDocumentsHaveTypes() {
    return _.all(this.documentBatch.documents, (d) => {
      return d.type;
    });
  }
  _hiddenDocumentsExist() {
    return _.some(this.documentBatch.documents, (d) => {
      return d.hidden;
    });
  }
  _allDocumentsHaveGroups() {
    return _.all(this.documentBatch.documents, (d) => {
      return d.data && d.data.group_id;
    });
  }
  _allFactorInvoicesHaveDebtorSelection() {
    return _.all(this.documentBatch.factor_invoices, (i) => {
      return i.factor_broker_id || i.data["no_debtor_selected"];
    });
  }
  _groupingErrorsExist() {
    return _.some(this.documentBatch.documents, (d) => {
      return (d.data["grouping_errors"] || []).length > 0;
    });
  }
  updateStep() {
    if (!_.isNull(this.documentBatch.single_carrier)) {
      if (this._allDocumentsHaveTypes()) {
        if (this._groupingErrorsExist()) {
          this.step = "assignTypes";
        } else if (this._allDocumentsHaveGroups()) {
          if (factorInIndexerMode(this._propsLocation) && this._allFactorInvoicesHaveDebtorSelection()) {
            this.step = "review";
          } else {
            this.step = this._allDocumentsGroupedStep();
          }
        } else {
          if (!this.documentBatch.attempted_to_auto_group) {
            this.step = "assignTypes";
          } else {
            this.step = "assignGroups";
          }
        }
      } else {
        this.step = "assignTypes";
      }
    } else {
      this.step = "assignCarrier";
    }
  }
}
export default DocumentIndexerService;
